import { FC } from 'react'
import Swal from 'sweetalert2'
import { IconPaths, showAlertLoading, showConfirmAlert, showError } from '_metronic/helpers'
import { RowActions, useModal, useToast } from 'app/components'
import { ExameModal } from '../../components/modal/ExameModal'
import { deleteExame, getExameById } from '../../core/_requests'
import { ExameList } from '../../core/_models'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useT } from '_metronic/i18n/Metronici18n'

type Props = {
  exame: ExameList
}

export const ExamesActionsCell: FC<Props> = ({ exame }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const { t } = useT()
  const nome = exame.nome || t('exame.label')

  const openEditModal = () =>
    showModal({
      title: t('modal.editar_exame'),
      content: <ExameModal />,
      fetchers: {
        exame: () => getExameById(exame.id),
      },
    })

  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir exame?',
      text: `${nome} será excluído do catálogo. Para só tirá-lo de uso, edite e marque como inativo.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await deleteExame(exame.id)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi excluído.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Editar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[{ label: 'Excluir', onClick: askDelete, danger: true }]}
    />
  )
}
